import { useLanguage } from '../LanguageContext';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { t } = useLanguage();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance.get("/api/check-auth", { withCredentials: true })
      .then(response => {
        setIsAuthenticated(true);
        setRole(response.data.role);
      })
      .catch(error => {
        if (error.response?.status === 401) {
          setIsAuthenticated(false);
        } else {
          console.error("Temporary auth check/server error:", error);
          setIsAuthenticated(false);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>{t("Loading...")}</p>;

  if (!isAuthenticated) return <Navigate to="/login" />;

  if (requiredRole && !requiredRole.includes(role)) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default ProtectedRoute;